import { trailersSelector, TrailerSelectorProps, useGetAllTrailersQuery } from "@ots-frontend/ots-data";
import { BaseTrailerSelect, BaseTrailerSelectProps } from "./BaseTrailerSelect";
import { useMemo } from "react";
import {skipToken} from "@reduxjs/toolkit/query";

export type TrailerSelectProps = Omit<BaseTrailerSelectProps, "entities" | "loading"> & {
  selector?: TrailerSelectorProps
}

export const TrailerSelect = (props: TrailerSelectProps) => {
  const { selector, ...rest } = props;

  const selectTrailers = useMemo(() => {
    return trailersSelector();
  }, []);

  const { trailers, isLoading } = useGetAllTrailersQuery(selector?.regionId ?? skipToken, {
    selectFromResult: (result) => ({
      trailers: selectTrailers(result, selector),
      isLoading: result.isLoading
    })
  });

  return <BaseTrailerSelect entities={trailers} loading={isLoading} {...rest} />;
};
